export const integrationPartnersRoutes = [
  {
    path: '/integration-partners',
    name: 'IntegrationPartners',
    component: () =>
      import(
        /* webpackChunkName: "integrationPartners" */ '@/views/Dashboard/IntegrationPartners/IntegrationPartners.vue'
      ),
  },
  {
    path: '/integration-partners/invite/:name',
    name: 'IntegrationPartnersInviteDetail',
    component: () =>
      import(
        /* webpackChunkName: "integrationPartnersDetail" */ '@/views/Dashboard/IntegrationPartners/IntegrationPartnersInviteDetail.vue'
      ),
  },
  {
    path: '/integration-partners/add',
    name: 'IntegrationPartners',
    component: () =>
      import(
        /* webpackChunkName: "integrationPartnersAdd" */ '@/views/Dashboard/IntegrationPartners/IntegrationPartnersAdd.vue'
      ),
  },
  {
    path: '/integration-partners/create',
    name: 'IntegrationPartnersCreate',
    component: () =>
      import(
        /* webpackChunkName: "integrationPartnersCreate" */ '@/views/Dashboard/IntegrationPartners/IntegrationPartnersCreate.vue'
      ),
  },
  {
    path: '/integration-partners/:name',
    name: 'IntegrationPartnersDetail',
    component: () =>
      import(
        /* webpackChunkName: "integrationPartnersDetail" */ '@/views/Dashboard/IntegrationPartners/IntegrationPartnersDetail.vue'
      ),
  },
  {
    path: '/invite/vendor',
    name: 'InviteVendor',
    component: () =>
      import(
        /* webpackChunkName: "inviteVendor" */ '@/views/Dashboard/IntegrationPartners/InviteVendor.vue'
      ),
  },
];
